import r from "../managers/braze-instance.js";
import { logger as N, IndexedDBAdapter as st } from "../../shared-lib/index.js";
import ne, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function disableSDK() {
  const e = r.rn();
  e && e.requestImmediateDataFlush();
  const n = new ne.se(null, !0),
    a = "This-cookie-will-expire-in-" + n.le();
  n.store(s.me, a);
  const i = st.Ls.Fs;
  new st(i, N).setItem(i.Ms.pe, i.be, !0),
    N.info("disableSDK was called"),
    r.destroy(!1),
    r.fe(!0);
}
